var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M425.5,135.4c4.7-5.9,7.5-13.5,7.5-21.6c0-19.2-15.6-34.8-34.8-34.8c-8.2,0-15.7,2.8-21.6,7.5 C342.6,62.3,300.9,48,256,48C141.1,48,48,141.1,48,256s93.1,208,208,208s208-93.1,208-208C464,211.1,449.7,169.4,425.5,135.4z  M391.8,391.8c-17.6,17.6-38.2,31.5-61.1,41.2c-23.7,10-48.8,15.1-74.8,15.1c-25.9,0-51.1-5.1-74.8-15.1 c-22.9-9.7-43.4-23.5-61.1-41.2c-17.6-17.6-31.5-38.2-41.2-61.1c-10-23.7-15.1-48.8-15.1-74.8c0-25.9,5.1-51.1,15.1-74.8 c9.7-22.9,23.5-43.4,41.2-61.1s38.2-31.5,61.1-41.2c23.7-10,48.8-15.1,74.8-15.1c25.9,0,51.1,5.1,74.8,15.1 c12.7,5.4,24.7,12.1,35.9,20c-2.1,4.5-3.3,9.5-3.3,14.9c0,19.2,15.6,34.8,34.8,34.8c5.3,0,10.3-1.2,14.9-3.3 c7.9,11.2,14.6,23.2,20,35.9c10,23.7,15.1,48.8,15.1,74.8c0,25.9-5.1,51.1-15.1,74.8C423.3,353.6,409.5,374.2,391.8,391.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 96.1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.38dce54f988a8d464a6d370923ffd7ae.svg";
export { ForwardRef as ReactComponent };